import { COMMON_ENV } from '@common/constants/common-env.constant';

export const ENV = {
    ...COMMON_ENV,
    REACT_APP_ADDRESS_TYPE: process.env.REACT_APP_ADDRESS_TYPE,
    REACT_APP_MM_DC_IDS: process.env.REACT_APP_MM_DC_IDS,
};
